<template>
  <div class="leftSide-container">
    <div class="main">
      <ul v-for="item in liData">
        <router-link class="link" :to="item.href" tag="a">
          <li>{{item.title}}</li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "leftSide",
    props: {
      liData: {
        type: Array
      }
    },
    methods: {}
  }
</script>

<style scoped lang="scss">
  .leftSide-container {
    background-color: #b1b1b1;
    width: 210px;

    .main {
      a {
        color: white;
        text-decoration: none;

        li {
          height: 30px;
          list-style: none;
          line-height: 30px;
          text-align: center;
        }

        li:hover {
          background-color: #8a8a8a;
        }
      }

      .router-link-active {
        display: block;
        color: gold;
        font-weight: bolder;
        background-color: #8a8a8a;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/leftSide.vue